

















































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
import echarts from "echarts";
import XLSX from "@/lib/Common/excel";

class PageUserRequest extends PageRequest {
  keyword: string;
  areaId: number;
  startTime: string;
  endTime: string;
  totaltype: number;
  operaType: number;
}

@Component({
  components: {},
})
export default class LiquidlevelValueReport extends AbpBase {
  pagerequest: PageUserRequest = new PageUserRequest();
  searchName: string = ""; //树形搜索名称
  treedata: any[] = [];
  areaTreeList: any[] = [];
  itemId: string = "0";
  height: number = 300;
  usebar: any; //图表
  useCount: number = 0;
  loadsear: boolean = false;
  splitnum: number = 0.15;
  get list() {
    return this.$store.state.pressurerecord.list;
  }
  get loading() {
    return this.$store.state.pressurerecord.loading;
  }
  pageChange(page: number) {
    this.$store.commit("pressurerecord/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("pressurerecord/setPageSize", pagesize);
    this.getpage();
  }
  changeSort(key) {
    this.pagerequest.sorting = key.key + " " + key.order;
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    //console.log(item)
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("pressurerecord/setCurrentPage", 1);
    this.getpage();
  }
  getSearch() {
    this.$store.commit("pressurerecord/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    this.loadsear = true;
    await this.$store
      .dispatch({
        type: "pressurerecord/getLiquidLevelValue",
        data: this.pagerequest,
      })
      .then((val) => {
        this.loadsear = false;
        this.usebar.setOption(this.$data.baroption(val.barData), true);
        this.$store.state.pressurerecord.totalCount = val.rowCount;
        if (val.tableData != null) {
          this.$store.state.pressurerecord.list = val.tableData;
        } else {
          this.$store.state.pressurerecord.list = [];
        }
      })
      .catch((err) => {
        this.loadsear = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
  }
  get pageSize() {
    return this.$store.state.pressurerecord.pageSize;
  }
  get totalCount() {
    return this.$store.state.pressurerecord.totalCount;
  }
  get currentPage() {
    return this.$store.state.pressurerecord.currentPage;
  }
  //时间改变
  changdate(val) {
    if (val.length > 1) {
      this.pagerequest.startTime = Moment(val[0], "YYYY-MM-DD HH:mm:ss")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      this.pagerequest.endTime = Moment(val[1], "YYYY-MM-DD HH:mm:ss")
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.treedata = this.areaTreeList;
      return;
    }
    const rebuildData = (value, treeList) => {
      let newarr = [];
      treeList.forEach((element) => {
        if (element.children && element.children.length) {
          if (element.title != null && element.title.indexOf(value) > -1) {
            element.expand = true;
            newarr.push(element);
          }
          const ab = rebuildData(value, element.children);
          const obj = {
            ...element,
            expand: true,
            children: ab,
          };
          if (ab && ab.length) {
            newarr.push(obj);
          }
        } else {
          if (element.title != null && element.title.indexOf(value) > -1) {
            newarr.push(element);
          }
        }
      });
      return newarr;
    };
    this.treedata = [];
    this.treedata = rebuildData(value, this.areaTreeList);
  }
  //区域树形
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.treedata = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Areas"),
      key: "areaName",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.areaName,
            },
          },
          params.row.areaName
        );
      },
    },
    {
      title: this.L("DeviceNo"),
      key: "deviceNo",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.deviceNo,
            },
          },
          params.row.deviceNo
        );
      },
    },
    {
      title: this.L("Location"),
      key: "location",
      width: 150,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
    {
      title: this.L("ReadTime"),
      key: "gatherTime",
      width: 150,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.gatherTime == null
            ? ""
            : Moment(params.row.gatherTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("LiquidLevelValue"),
      key: "liquidLevelValue",
      sortable: true,
      width: 150,
    },
    {
      title: this.L("LastReportTime"),
      key: "reportTime",
      sortable: true,
      width: 150,
    },
  ];
  async created() {
    this.pagerequest.startTime = Moment()
      .add(-6, "days")
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    await this.getAreaTree();
    this.getpage();
  }
  mounted() {
    this.pagerequest.totaltype = 1;
    if (window.innerHeight > 800) {
      (document.getElementById("echarts") as HTMLDivElement).style.height =
        "300px";
      this.height = window.innerHeight - 610;
    } else {
      (document.getElementById("echarts") as HTMLDivElement).style.height =
        "150px";
      this.height = window.innerHeight - 460;
    }
    this.usebar = echarts.init(
      document.getElementById("echarts") as HTMLDivElement
    );
    //自动缩放
    window.addEventListener("resize", () => {
      this.usebar.resize();
    });
  }
  //导出数据
  async exportdata() {
    this.loadsear = true;
    this.pagerequest.operaType = 1;
    await this.$store
      .dispatch({
        type: "pressurerecord/getLiquidLevelValue",
        data: this.pagerequest,
      })
      .then((val) => {
        this.loadsear = false;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        if (val.tableData.length != null && val.tableData.length > 0) {
          val.tableData.forEach((ele) => {
            let info = ite.filter((p) => {
              return p.id == ele.meterType;
            });
            if (info.length > 0) {
              ele.meterType = info[0].name;
            }
            ele.gatherTime = Moment(ele.gatherTime).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          });
          this.exportList(val.tableData);
        }
      })
      .catch((err) => {
        this.loadsear = false;
        this.$Modal.info({
          title: this.L("Tips"),
          content: err,
        });
      });
  }
  //XLXS导出数据
  exportList(list) {
    let title = [
      "区域",
      "设备编号",
      "安装位置",
      "读表时间",
      "压力值",
      "温度值",
      "时间",
    ];
    let keylist = [
      "areaName",
      "deviceNo",
      "location",
      "gatherTime",
      "pressureValue",
      "temperatureValue",
      "reportTime",
    ];
    let filename = Moment().format("YYYYMMDDHHmmss");
    const param = {
      title: title,
      key: keylist,
      data: list,
      autoWidth: true,
      filename: filename,
    };
    XLSX.export_array_to_excel(param);
  }
  data() {
    return {
      datepicker: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              return [start, end];
            },
          },
        ],
      },
      //柱形图参数
      baroption(bardto) {
        return {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "line", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          legend: {
            data: bardto.legend,
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              data: bardto.xAxis,
            },
          ],
          yAxis: [
            {
              type: "value",
            },
          ],
          series: bardto.series,
        };
      },
    };
  }
}
